import axios from "axios";

export const saveCalendarSettings = ({
  annualCalendarId,
  planning,
  organization,
  year,
  zone
}) => {
  const requestUrl = `/team/save/annual-calendar`;

  let formData = new FormData();
  annualCalendarId && formData.append("annualCalendarId", annualCalendarId);
  formData.append("holidays", JSON.stringify(planning.holidays));
  formData.append("annualHolidays", JSON.stringify(planning.annualHolidays));
  formData.append("workingDays", JSON.stringify(planning.workingDays));
  formData.append("organizationId", organization.id);
  formData.append("year", year);
  formData.append("zone", zone);

  return axios.post(requestUrl, formData);
};

export const getCalendarSettings = (id, year, zone) => {
  const requestUrl = `/team/annual-calendar`;

  return axios.get(requestUrl, {
    params: {
      organizationId: id,
      year: year,
      zone: zone
    }
  });
};

export const getCollaboratorAbsenceCalendarSettings = (
  organizationId,
  collaboratorId,
  year,
  collaboratorUid,
  erpId
) => {
  const requestUrl = `/team/collaborator-absence`;

  return axios.get(requestUrl, {
    params: {
      organizationId: organizationId,
      collaboratorId: collaboratorId,
      year: year,
      collaboratorUid: collaboratorUid,
      erpId: erpId
    }
  });
};

export const saveCollaboratorAbsenceCalendarSettings = ({
  user,
  planning,
  organization,
  collaboratorId,
  files,
  year,
  month,
  isUpdating
}) => {
  const requestUrl = `/team/collaborator-absence/save`;

  let formData = new FormData();
  formData.append("planning", JSON.stringify(planning));
  formData.append("organizationId", organization.id);
  formData.append("collaboratorId", collaboratorId);
  formData.append("year", year);
  formData.append("month", month);
  formData.append("user", user);
  formData.append("isUpdating", isUpdating);
  files.forEach((element, i) => {
    formData.append("files[" + i + "]", element, element.name);
  });

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/calendar-settings.js